// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_el","cardHeaderIcon_styleDefault":"c-e_em","cardHeaderIcon_styleRed":"c-e_en","cardHeaderIcon__content":"c-e_eo"};